import { t, defineMessage } from '@lingui/macro';

export const freeDescriptorCode = 'free';
export const freeDescriptorMessage = t({ id: 'free' });

defineMessage({
    id: 'free',
    message: 'Free',
    comment: 'Meta for free item',
});
